import { createContext, useContext, useMemo, useState } from "react";

type ContextValue = {
	isUploading: boolean;
	setFieldUploading: (field: string, uploading: boolean) => void;
};

export const DirectUploadStatusContext = createContext<ContextValue>({
	isUploading: false,
	setFieldUploading: () => {}
});

export const useDirectUploadStatusProvider = (): ContextValue => {
	const [uploadingFields, setUploadingFields] = useState<
		Record<string, boolean>
	>({});
	const setFieldUploading = (field: string, uploading: boolean): void => {
		setUploadingFields((prev) => ({ ...prev, [field]: uploading }));
	};
	const isUploading = useMemo(
		() => Object.values(uploadingFields).some(Boolean),
		[uploadingFields]
	);
	return { isUploading, setFieldUploading };
};

export const useDirectUploadStatus = (): ContextValue =>
	useContext(DirectUploadStatusContext);
